module.exports = __webpack_public_path__ + "img/b737785.jpg";